import {
  takeLatest, select, put,
} from 'redux-saga/effects'
import moment from 'moment'
import request from '@/helpers/axios'
import {
  GET_CONSUMPTION_ANALYSIS_TABLE_DATA,
  CONSUMPTION_ANALYSIS_TABLE,
} from '@/store/actions/consumptionAnalysis'
import {
  responseTableData,
  errorTableData,
} from '@/store/actions/consumptionAnalysis/getTableData'
import { getSelectedNode } from '@/store/selectors/appSettings'
import createNotifications from '@/helpers/notification'
import {
  getForm,
  getTableParameters,
} from '@/store/selectors/consumptionAnalysis'
import {
  requestConsumptionAnalysisSavings,
} from '@/store/actions/consumptionAnalysis/getAvarage'
import { OUTDOOR_LIGHTING } from '@/constants/names'
import {
  RESOURCE_ANALYTICS_TABLE_ENDPOINT,
} from '@/constants/apiRoutes'
import { setGlobalLoading } from '@/store/actions/appSettings'

const NO_DATA_FOR_PERIOD = 'no.data.was.found.for.the.specified.period'

function* getGraphDataSaga() {
  const toast = createNotifications()
  try {
    yield put(setGlobalLoading(true))
    const formValues = yield select(getForm)
    const node = yield select(getSelectedNode)
    const tableParameters = yield select(getTableParameters)
    const {
      type,
      dateFirst,
      dateSecond,
      integrationTypes,
    } = formValues
    if (integrationTypes === OUTDOOR_LIGHTING) {

      const response = yield request({
        url: RESOURCE_ANALYTICS_TABLE_ENDPOINT({
          aliasId: node.asuId,
          startDate: moment(dateFirst).format('DD.MM.YYYY'),
          endDate: moment(dateSecond).format('DD.MM.YYYY'),
          includedColumns: tableParameters.activeFields,
          pageNumber: tableParameters.page - 1,
          pageSize: tableParameters.perPage,
          parentId: node.id,
          query: tableParameters.requestQuery || '',
          sort: [`${tableParameters.sort.field}: ${tableParameters.sort.direction}`],
          type: type.toUpperCase(),
        }),
        method: 'get',
      })

      if (response) {
        const { error } = response.data

        if (error) {
          yield put(setGlobalLoading(false))
          yield put(errorTableData())
        } else {
          yield put(setGlobalLoading(false))
          yield put(responseTableData({
            content: response.data.content,
            totalElements: response.data.pageable.totalElements,
          }))
          yield put(requestConsumptionAnalysisSavings({
                aliasId: node.asuId,
                startDate: moment(dateFirst).format('DD.MM.YYYY'),
                endDate: moment(dateSecond).format('DD.MM.YYYY'),
                includedColumns: tableParameters.activeFields,
                pageNumber: tableParameters.page - 1,
                pageSize: tableParameters.perPage,
                parentId: node.id,
                query: tableParameters.requestQuery || '',
                sort: [`${tableParameters.sort.field}: ${tableParameters.sort.direction}`],
                type: type.toUpperCase()
              }))
        }
      } else {
        yield put(setGlobalLoading(false))
        yield put(errorTableData())
      }
    }
  } catch (error) {
    const { response: { data: { message } } } = error
    const node = yield select(getSelectedNode)
    yield put(setGlobalLoading(false))
    yield put(errorTableData(error))
    if (message === NO_DATA_FOR_PERIOD) {
      toast({
        title: 'ОШИБКА ОПЕРАЦИИ!',
        description: 'Данных за указанный период не найдено',
        type: 'error',
      })
    } else {
      toast({
        title: 'Ошибка сервиса!',
        description: `Hе удалось получить данные "${node.name}".\nПовторите попытку позже`,
        type: 'error',
      })
    }
  }
}

export default function* root() {
  yield takeLatest(GET_CONSUMPTION_ANALYSIS_TABLE_DATA.REQUEST, getGraphDataSaga)
  yield takeLatest(CONSUMPTION_ANALYSIS_TABLE.PAGE, getGraphDataSaga)
  yield takeLatest(CONSUMPTION_ANALYSIS_TABLE.PER_PAGE, getGraphDataSaga)
  yield takeLatest(CONSUMPTION_ANALYSIS_TABLE.SORT, getGraphDataSaga)
  // yield takeLatest(CONSUMPTION_ANALYSIS_TABLE.SELECTED_FIELDS, getGraphDataSaga)
  yield takeLatest(CONSUMPTION_ANALYSIS_TABLE.REQUEST_QUERY, getGraphDataSaga)
}
